'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplCandyGuard = require('@metaplex-foundation/mpl-candy-guard');
var Serializer = require('../../../types/Serializer.cjs');
var DateTime = require('../../../types/DateTime.cjs');

/**
 * The startDate guard determines the start date of the mint.
 * Before this date, minting is not allowed.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const startDateGuardManifest = {
  name: 'startDate',
  settingsBytes: 8,
  settingsSerializer: Serializer.mapSerializer(Serializer.createSerializerFromBeet(mplCandyGuard.startDateBeet), settings => ({
    date: DateTime.toDateTime(settings.date)
  }), settings => settings)
};

exports.startDateGuardManifest = startDateGuardManifest;
//# sourceMappingURL=startDate.cjs.map
